import React, { useState } from "react";
import { Autocomplete, Select, Table, Button } from "@ann/web-components";
import Footer from "../../../../../../components/Footer/Footer";
import {
  AuditContainer,
  FilterContainer,
  TableContainer,
} from "./Audit.styled";

const Audit = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [autocompleteValue, setAutocompleteValue] = useState("");
  const [actionValue, setActionValue] = useState([]);
  const [lastUpdateValue, setLastUpdateValue] = useState([]);

  const handleAutocompleteChange = (value) => {
    setAutocompleteValue(value);
  };

  const handleAutocompleteClear = () => {
    setAutocompleteValue("");
  };

  const handleActionChange = (value) => {
    setActionValue(value);
  };

  const handleLastUpdateChange = (value) => {
    setLastUpdateValue(value);
  };

  const handleClearAll = () => {
    setAutocompleteValue("");
    setActionValue([]);
    setLastUpdateValue([]);
  };

  const emptyOrValue = (arr) => (arr.length > 0 ? arr : undefined);

  const headers = [
    { value: "action", label: "Action" },
    { value: "detail", label: "Detail" },
    { value: "modifiedBy", label: "Modified by" },
    { value: "timestamp", label: "Timestamp" },
  ];

  const tableData = [
    {
      uuid: "1",
      action: "Modified",
      detail: "Trigger configuration updated",
      modifiedBy: "John Doe",
      timestamp: "2024-01-15 10:30:00",
    },
    {
      uuid: "2",
      action: "Created",
      detail: "Trigger status changed to active",
      modifiedBy: "Jane Smith",
      timestamp: "2024-01-14 15:45:00",
    },
    {
      uuid: "3",
      action: "Deleted",
      detail: "Trigger settings updated",
      modifiedBy: "Mike Johnson",
      timestamp: "2024-01-13 09:20:00",
    },
    {
      uuid: "4",
      action: "Modified",
      detail: "Trigger parameters modified",
      modifiedBy: "Sarah Wilson",
      timestamp: "2024-01-12 14:15:00",
    },
    {
      uuid: "5",
      action: "Created",
      detail: "Trigger template updated",
      modifiedBy: "David Brown",
      timestamp: "2024-01-11 11:30:00",
    },
  ];

  return (
    <>
      <AuditContainer>
        <div className="title">Activity Log</div>
        <div className="description">
          Review the full timeline of edits to this workflow.
        </div>
      </AuditContainer>
      <FilterContainer>
        <Autocomplete
          style={{ fontSize: "5px" }}
          value={autocompleteValue}
          onChange={handleAutocompleteChange}
          onSearch={() => {}}
          onSuggestionSelect={() => {}}
          onClear={handleAutocompleteClear}
          placeholder="Search workflows..."
          suggestions={["Trigger 1", "Trigger 2", "Trigger 3"]}
          disabled={true}
        />
        <Select
          label="Action"
          placeholder="Action"
          onSelectionChange={handleActionChange}
          size="small"
          value={emptyOrValue(actionValue)}
          width="auto"
          minWidth="139px"
          disabled={true}
        >
          <Select.Menu>
            <Select.Item value="created" label="Created">
              Created
            </Select.Item>
            <Select.Item value="modified" label="Modified">
              Modified
            </Select.Item>
            <Select.Item value="deleted" label="Deleted">
              Deleted
            </Select.Item>
          </Select.Menu>
        </Select>
        <Select
          label="Last Update"
          placeholder="Last Update"
          onSelectionChange={handleLastUpdateChange}
          size="small"
          value={emptyOrValue(lastUpdateValue)}
          width="auto"
          minWidth="139px"
          disabled={true}
        >
          <Select.Menu>
            <Select.Item value="today" label="Today">
              Today
            </Select.Item>
            <Select.Item value="yesterday" label="Yesterday">
              Yesterday
            </Select.Item>
            <Select.Item value="lastWeek" label="Last Week">
              Last Week
            </Select.Item>
            <Select.Item value="lastMonth" label="Last Month">
              Last Month
            </Select.Item>
          </Select.Menu>
        </Select>
        <Button
          label="Clear Filters"
          size="medium"
          type="secondary"
          onClick={handleClearAll}
          disabled={true}
        />
      </FilterContainer>
      <TableContainer>
        <Table
          headers={headers}
          data={tableData}
          action={false}
          showActions={false}
        />
      </TableContainer>

      <Footer
        currentPage={currentPage}
        totalPages={1}
        itemsPerPage={10}
        totalItems={5}
        onPageChange={setCurrentPage}
        disabled={false}
      />
    </>
  );
};

export default Audit; 